import m from 'mithril';
import Requester from './request';
import Gateway from './app_settings';
import StyleUtilities from './utilities/style_utilities';
import RouterService from './services/router.service';
import i18n from './i18n/i18n';
import ModalManager from "./modal";
import UnsavedChanges from "./unsaved_changes";

function endSession() {
    UnsavedChanges.releaseAll();

    return Requester.post(Gateway.identity + "logout", null)
        .finally(function () {
            SessionController.clearSession();

            if (localStorage.getItem("sso-logout")) {
                const ssoLogoutUrl = localStorage.getItem("sso-logout");
                localStorage.removeItem("sso-logout");

                // Perform sso-logout in the background and return to organisations login page
                var img = new Image();
                img.onload = function () {
                    RouterService.navigateToPublicLogin();
                };
                img.onerror = function () {
                    RouterService.navigateToPublicLogin();
                };
                img.src = ssoLogoutUrl;
            } else {
                RouterService.navigateToPublicLogin();
            }
        });
}

const SessionController = {
    session: null,
    logout: function () {
        if (!UnsavedChanges.isDirty()) {
            endSession();
            return;
        }

        UnsavedChanges.confirmDiscard(function () {
            endSession();
        });
    },
    clearSession: function () {
        console.log('Clearing session.');
        SessionController.session = null;
        localStorage.removeItem("session");
        localStorage.removeItem("auth");
        ModalManager.closeAll();
    },
    checkSession: function () {
        if (!localStorage.getItem("auth")) {
            SessionController.clearSession();
            m.redraw();
        }
    },
    setSession: function (res) {
        return new Promise(function (resolve) {
            const localSession = localStorage.getItem("session") ? JSON.parse(localStorage.getItem("session")) : {};

            if (!SessionController.session)
                SessionController.session = {};

            if (res.identity) {
                SessionController.session.identity = res.identity;
                localSession.identity = res.identity;
                if (res.identity.rights.length == 0) {
                    localStorage.setItem("auth", false);
                } else {
                    localStorage.setItem("auth", true);
                }
            } else {
                localStorage.setItem("auth", false);
            }

            if (res.environment) {
                SessionController.session.environment = res.environment;
                localSession.environment = res.environment;
            }

            localStorage.setItem("session", JSON.stringify(localSession));


            SessionController.setStyle();

            resolve();
        });
    },
    setStyle: function () {
        if (SessionController.session && SessionController.session.environment) {
            const existing = document.getElementById("custom-styles");
            if (existing)
                existing.parentNode.removeChild(existing);

            let primary = SessionController.session.environment.primaryColour;
            primary = null; // todo primary colour from the session has a wrong value.
            const lightText = SessionController.session.environment.lightText;

            if (primary || lightText) {
                let styles = ":root * {";
                if (primary) {
                    styles += "--accent-1: " + primary + ";";
                    styles += "--accent-2: " + StyleUtilities.adjustColour(primary, 30) + ";";
                }

                if (lightText !== null)
                    styles += lightText ? "--text: #fff;" : "--text-1: #000;";

                styles += "}";
                const stylesheet = document.createElement("style");
                stylesheet.type = "text/css";
                stylesheet.innerText = styles;
                stylesheet.id = "custom-styles";
                document.head.appendChild(stylesheet);
            }
        }
    },
    getSession: function () {
        const expired = !(localStorage.getItem("auth") === "true");
        return new Promise(function (resolve, reject) {
            if (!expired && SessionController.session) {
                resolve(SessionController.session);
            } else if (!expired && localStorage.getItem("session")) {
                SessionController.session = JSON.parse(localStorage.getItem("session"));
                SessionController.setStyle();
                resolve(SessionController.session);
            } else {
                Requester.get(Gateway.identity + "auth" + (!(localStorage.getItem("auth") === "true") ? "?env=true" : ""))
                    .then(function (result) {
                        SessionController.setSession(result);
                        i18n.setLocale();
                        resolve(result);
                    })
                    .catch(function () {
                        console.log('ERROR when fetching a new session.')
                        reject(null);
                    });
            }
        });
    },
    verifySso: function (token) {
        return new Promise(function (resolve, reject) {
            Requester.post(Gateway.identity + "login/ext?token=" + token)
                .then(function (result) {
                    SessionController.setSession(result);
                    resolve();
                })
                .catch(function (error) {
                    reject(error);
                })
                .finally(function () {
                    window.history.replaceState(null, "", window.location.pathname);
                });
        });
    },
    sso: function () {
        return !!(SessionController.session && SessionController.session.identity && SessionController.session.identity.sso);
    },
    getCookie: function (name) {
        const nameEquals = name + "=";
        const cookies = document.cookie.split(';');
        for (let i = 0; i < cookies.length; i++) {
            let c = cookies[i];

            while (c.charAt(0) === ' ')
                c = c.substring(1, c.length);

            if (c.indexOf(nameEquals) === 0)
                return c.substring(nameEquals.length, c.length);
        }
        return null;
    },
    setCurrentSession: function () {
        return new Promise(function (resolve, reject) {
            Requester.get(Gateway.identity + "auth" + (!(localStorage.getItem("auth") === "true") ? "?env=true" : ""))
                .then(function (result) {
                    SessionController.setSession(result);
                    i18n.setLocale();
                    resolve(result);
                })
                .catch(function () {
                    console.log('ERROR when fetching a new session.');
                    reject(null);
                });
        });
    },
};

export default SessionController;
